import moment from "moment";
import "moment/locale/de-at";

const dateFormat = "DD.MM.YYYY";

export const validateMessagesDE = {
  required: "Wird benötigt!",
  types: {
    email: "Ist keine gültige E-Mail Adresse!",
    number: "Ist keine Nummer!",
    innerText: "Wird benötigt!",
  },
  number: {
    range: "${label} muss zwischen ${min} und ${max} sein",
  },
  errorMessageText: "Wird benötigt!",
  errorMessageObject: "Wird benötigt!",
  errorMessageNoUpload:
    "Sieht so aus als hättest du deine Produktion noch nicht hochgeladen! Bitte check das nochmal ab.",
  errorOnMetaDataUpload:
    "Es gab ein Problem beim Versenden der Daten. Bitte versuch es nocheinmal oder wende dich an die Administatoren: ",
  errorInputStringExceedsCharLimit: "Eingabe ist zu lange",
  ageRestriction: "Alter zwischen 6 und 22!",
};

export const generalTextsDE = {
  currentDate: moment(new Date()).format(dateFormat),
  pdfHeadline1: "EINREICHBOGEN VIDEO UND FILMTAGE",
  applicationPhaseInitMessage: "Intialisiere ...",
  applicationPhaseDisabledMessage:
    "Zur Zeit finden keine Einreichungen statt. Die nächste Einreichphase startet diesen April.",
  uploadSuccessMessage:
    "Liebe Filmemacherin, lieber Filmemacher, Deine Daten wurden erfolgreich übermittelt. Wir freuen uns sehr über deine Einreichung! In Kürze senden wir dir ein Bestätigungs E-Mail zu, in dem du erfährst, wie es mit deiner Einreichung weitergeht.",
  privacyLink: "https://www.wienxtra.at/datenschutz/",
  mainTitle: "VIDEO & FILMTAGE",
  mainSubTitle1: "DAS KURZFILMFESTIVAL FÜR JUNGE FILMEMACHER*INNEN",
  mainSubTitle2: "BIS 22 JAHRE",
  mainSubTitle3: "",
  mainCookieInfoText1: "",
  mainCookieInfoText2: "",
  mainLongDescription: "",
  titleSubSectionConditions: "Datenschutzbestimmungen",
  save: "Speichern",
  otherParticipants: "",

  titleSection1: "TITEL",
  titleSection2: "FILMEMACHER*INNEN",
  titleSection3: "KONTAKTPERSON",
  titleSection4: "DETAILS ZUR PRODUKTION",
  titleSection5: "NEWSLETTER",
  newLetterAgreementLabel: "Bestätigung: ",
  titleSection6: "RECHTE & EINVERSTÄNDNISERKLÄRUNG",
  conditionsOfParticipationLabel: "Bestätigung: ",
  conditionsOfParticipation: `Teilnahmebedingungen: Dein Film ist nicht länger als 30 Minuten und nicht älter als 1 Jahr. Die Produzent*innen sind zum Zeitpunkt der Produktion nicht älter als 22 Jahre gewesen. Gezeigt werden nur Filme/Videos, bei deren Vorführung die Produzent*innen anwesend sein können! Wir können leider keine Reisekosten übernehmen.`,

  participationConditionsAgreementPart1:
    "Ich/wir erkenne/n die Teilnahmebedingungen an und bestätige/n, dass alle im Film dargestellten Personen mit einer Vorführung im Rahmen der Video & Filmtage einverstanden sind. Dem WIENXTRA Medienzentrum erteile/n ich/wir die Genehmigung, Standbilder und kurze Filmclips aus der Produktion zu Werbezwecken auf Social Media, der Festival-Website sowie in der Presse zu verwenden, die Produktion für Archivzwecke zu kopieren und für nichtgewerbliche Vorführungen und Ausstrahlungen (z. B. OKTO, Web-TV) zu nutzen. Zudem darf/n mein/unser Name an Interessierte wie TV-Anstalten, Wettbewerbe oder Festivals weitergegeben werden. Es besteht kein rechtlicher Anspruch auf Aufnahme in das Festivalprogramm. Weiters habe ich die",
  participationConditionsAgreementPart2: "Datenschutzerklärung",
  participationConditionsAgreementPart3: "zur Kenntnis genommen.",

  newsLetterAgreement:
    "Ich stimme der Zusendung von festivalbezogenen Informationen per E-Mail und Post zu. Diese Zustimmung kann jederzeit widerrufen werden.",

  titleSection7: "ANWESENHEIT BEIM FESTIVAL",
  presenceAgreementPart1:
    "Ich bestätige hiermit, dass ich bzw. jemand aus dem Filmteam meinen/unseren Film ",
  presenceAgreementPart2:
    "während des Festivals persönlich in Wien ",
  presenceAgreementPart3:
    "vorstellen kann. Die Video & Filmtage 2026 finden ",
  presenceAgreementPart4:
    "vom 8. bis 11. Oktober 2026 ",
  presenceAgreementPart5: 
    "statt.",

  verificationHeadline: "VERIFIZIEREN",
  send: "Abschicken",
  upload: "HOCHLADEN",
  uploaded:
    "Du hast deine Dateien erfolgreich hochgeladen. Kontrolliere ob alle unbedingt benötigten Formulareinträge vorhanden sind und dann drücke auf Abschicken",
  yes: "Ja",
  no: "Nein",

  productionTitleLabel: "Titel der Produktion",
  productionTitlePlaceholder: "Welchen Namen hat deine/eure Produktion?",
  firstNameLabel: "Vorname",
  firstNamePlaceholder: "Vorname",
  lastNameLabel: "Nachname",
  lastNamePlaceholder: "Nachname",
  birthdateLabel: "Alter",
  nameMainContactLabel: "Name",
  nameMainContactPlaceholder: "Vorname des Hauptkontakts",
  lastNameMainContactPlaceholder: "Nachname des Hauptkontakts",
  addressMainContactLabel: "Adresse",
  addressMainContactStreetAndNumberPlaceholder: "Straße, Hausnummer",
  addressMainContactPostcodePlaceholder: "PLZ",
  addressMainContactPlacePlaceholder: "Ort",
  addressMainContactCountryPlaceholder: "Land",
  phoneMainContactLabel: "Telefon",
  phoneMainContactPlaceholder: "Nummer eingeben.",
  emailMainContactLabel: "E-Mail",
  emailMainContactPlaceholder: "email@hauptkontakt.at",
  productionLengthLabel: "Filmlänge",
  productionLengthPlaceholder: "Wie lang ist der Film/das Video?",
  productionTimeLabel: "Zeitraum der Produktion",
  productionTimePlaceholder: "Wie lange wurde daran gearbeitet?",
  productionShortSummaryLabel: "Kurze Inhaltsangabe",
  productionShortSummaryPlaceholder:
    "Ein Beschreibung des Inhalts für das Programmheft. (max. 200 Zeichen)",
  productionParticipantsDescriptionLabel: "Zu deiner/eurer Person",
  productionParticipantsDescriptionPlaceholder:
    "Wer bist du/seid ihr, wie habt ihr euch gefunden? (max. 200 Zeichen)",
  hasFurtherProjectsPlannedLabel: "Weitere Projekte: ",
  hasFurtherProjectsPlannedQuestion: "Planst du/plant ihr weitere Projekte?",

  furtherProjectsDescriptionLabel: "Weitere Projekte: ",
  furtherProjectsDescriptionPlaceholder:
    "Welche(s) ist/sind das? Beschreibung des Projekts / der Projekte...",
  hasReceivedHelpLabel: "Hilfe: ",
  helpReceivedQuestion: "Hat dir/euch jemand bei der Umsetzung geholfen?",
  productionParticipantHelpersLabel: "Beschreibung:",
  productionParticipantHelpersPlaceholder: "Wer und in welcher Form?",
  hasPublicContactInformationLabel1: "Öffentlicher Kontakt E-Mail: ",
  hasPublicContactInformationLabel2: "Öffentlicher Kontakt Website: ",
  hasPublicContactInformationQuestion1:
    "Wollt ihr dass folgende E-Mail Adresse auf der Video&Filmtage Website als Kontaktadresse angegeben wird?",
  hasPublicContactInformationQuestion2:
    "Wollt ihr dass folgende Webadresse (URL) auf der Video&Filmtage Website als Kontaktadresse angegeben wird?",
  emailPublicLabel: "E-Mail (Öffentlich)",
  emailPublicPlaceholder:
    "Öffentliche E-Mail Adresse für die Website: ich@meinedomain.at",
  websitePublicLabel: "Website (Öffentlich)",
  websitePublicPlaceholder:
    "Öffentliche Web Adresse für die Website: meinedomain.at",
   infoContact1: "Solltest du Probleme bei der Einreichung haben melde dich bitte bei uns:",
   infoContact2: "videoundfilmtage@wienxtra.at",
   infoContact3: "oder",
   infoContact4: "+43 1 909 4000 83444",
   infoContactNormalizedPhone: "+431909400083444"
};
